interface DataIconProps extends React.ComponentPropsWithoutRef<'svg'> {
  color?: string;
}

export function DataIcon({ color = 'currentColor', ...svgProps }: DataIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={'none'}
      {...svgProps}
    >
      <path
        d="M4.10254 11.0054C4.60656 11.0568 5 11.4829 5 12.0005V14.0005L4.99512 14.103C4.94359 14.6069 4.51745 15.0004 4 15.0005H2C1.44787 15.0005 1.00025 14.5525 1 14.0005V12.0005C1 11.4482 1.44772 11.0005 2 11.0005H4L4.10254 11.0054ZM9.10254 8.50535C9.60656 8.55679 10 8.98287 10 9.50047V14.0005C9.99975 14.5525 9.55205 15.0004 9 15.0005H7C6.48248 15.0005 6.05643 14.6069 6.00488 14.103L6 14.0005V9.50047C6 8.94819 6.44772 8.50047 7 8.50047H9L9.10254 8.50535ZM14.1025 6.00535C14.6066 6.05679 15 6.48287 15 7.00047V14.0005C14.9998 14.5525 14.5521 15.0004 14 15.0005H12C11.4825 15.0005 11.0564 14.6069 11.0049 14.103L11 14.0005V7.00047C11 6.44819 11.4477 6.00047 12 6.00047H14L14.1025 6.00535ZM2 14.0005H4V12.0005H2V14.0005ZM7 14.0005H9V9.50047H7V14.0005ZM12 14.0005H14V7.00047H12V14.0005ZM14.6836 0.613752C14.8973 0.438889 15.2119 0.470342 15.3867 0.684065C15.5613 0.89778 15.53 1.21242 15.3164 1.38719L10.0928 5.6616C9.82487 5.88068 9.48866 6.00044 9.14258 6.00047H6.8252C6.71955 6.00047 6.6167 6.03405 6.53125 6.09617L1.29395 9.90477C1.07076 10.0669 0.758157 10.0174 0.595703 9.79442C0.433364 9.57113 0.482852 9.2586 0.706055 9.09617L5.94336 5.28758C6.1997 5.10121 6.50826 5.00047 6.8252 5.00047H9.14258C9.25789 5.00044 9.37069 4.96018 9.45996 4.88719L14.6836 0.613752Z"
        fill={color}
        fillOpacity="0.96"
      />
    </svg>
  );
}
